module.exports = __webpack_public_path__ + "static/lascaux_control_03-5f8a59359dc9651ce8a1bdf4aa33625e.png";